import type { Instance } from "@gadgetinc/mobx-quick-tree";
import { RichString } from "../../RichString";
import { WorkspacePageType } from "../../WorkspacePageType";
import { createProblemFinder } from "../createProblemFinder";
import type { ShopifyBasePartnerAppConfig } from "../../connections/shopify/ShopifyBasePartnerAppConfig";

/*
 * NOTE: These problems are also mirrored in
 * ShopifyConnectionFormProblems, for local form state, any updates
 * here should also be applied there
 */
export const ShopifyPartnerAppConfigProblems = createProblemFinder<Instance<ReturnType<typeof ShopifyBasePartnerAppConfig>>>(
  {
    appURL: {
      url: {
        message: (_value, _attribute, _options, node) =>
          `Shopify app configuration with api key ${RichString.text(node.apiKey)} has an invalid app URL`,
        inContextMessage: "App URL must be a valid URL starting with https://",
        schemes: ["https"],
        allowLocal: true,
      },
    },
  },
  {
    name: "Shopify OAuth App Configuration",
    tabType: WorkspacePageType.PluginsIndex,
    fullMessages: false,
  }
);
